// extracted by mini-css-extract-plugin
export var cardIcon = "_l-5";
export var cardIconUnframed = "_l-9";
export var checkboxCard = "_l-0";
export var checkboxCardSelected = "_l-4";
export var disabled = "_l-2";
export var interactive = "_l-1";
export var outerBorder = "_l-3";
export var spacerMedium = "_l-8";
export var spacerSmall = "_l-7";
export var spacerXsmall = "_l-6";